import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgDragSelectDirective } from './drag-and-drop/drag-select.directive';
import { NgDragDropDirective } from './drag-and-drop/drag-drop.directive';
import { NgMouseTrailDirective } from './interaction/mouse-trail.directive';
import { NgClickOutsideDirective } from './interaction/click-outside.directive';
import { NgCopyDirective } from './interaction/copy.directive';
import { NgFocusElementDirective } from './interaction/focus-element.directive';
import { NgPreventClickPropagationDirective } from './interaction/prevent-click-propagation.directive';
import { NgSortableHeaderDirective } from './interaction/th-sortable.directive';
import { NgPasteDirective } from './interaction/paste.directive';
import { NgLinkDirective } from './navigation/link.directive';
import { NgRouteTransformerDirective } from './navigation/route-transformer.directive';
import { NgRouterLinkTransformerDirective } from './navigation/router-link-transformer.directive';
import { NgFileDownloadDirective } from './file-handling/download-file.directive';
import { NgFileOpenDirective } from './file-handling/file-open.directive';
import { NgDragDropSingleDirective } from './drag-and-drop/drag-drop-single.directive';
import { NgScrollDirective } from './interaction';
import { NgNumericOnlyDirective } from './interaction/only-numeric.directive';
import { NgLoadingSpinnerDirective } from './loading-spinner/loading-spinner.directive';


@NgModule({
	declarations: [
		//** Drag & Drop */
		NgDragDropDirective,
		NgDragSelectDirective,
		NgDragDropSingleDirective,

		//** File Handling */
		NgFileDownloadDirective,
		NgFileOpenDirective,

		//** Interactions */
		NgClickOutsideDirective,
		NgCopyDirective,
		NgPasteDirective,
		NgFocusElementDirective,
		NgMouseTrailDirective,
		NgPreventClickPropagationDirective,
		NgSortableHeaderDirective,
		NgScrollDirective,
		NgNumericOnlyDirective,

		//** Navigation */
		NgLinkDirective,
		NgRouteTransformerDirective,
		NgRouterLinkTransformerDirective
	],
	imports: [
		CommonModule,
		NgLoadingSpinnerDirective
	],
	exports: [
		//** Drag & Drop */
		NgDragDropDirective,
		NgDragSelectDirective,
		NgDragDropSingleDirective,

		//** File Handling */
		NgFileDownloadDirective,
		NgFileOpenDirective,

		//** Interactions */
		NgClickOutsideDirective,
		NgCopyDirective,
		NgPasteDirective,
		NgFocusElementDirective,
		NgMouseTrailDirective,
		NgPreventClickPropagationDirective,
		NgSortableHeaderDirective,
		NgScrollDirective,
		NgNumericOnlyDirective,
		NgLoadingSpinnerDirective,

		//** Navigation */
		NgLinkDirective,
		NgRouteTransformerDirective,
		NgRouterLinkTransformerDirective
	]
})
export class NgDirectivesModule {}
